import { render, staticRenderFns } from "./StyleTextIcon.vue?vue&type=template&id=6aa953cf&"
import script from "./StyleTextIcon.vue?vue&type=script&lang=js&"
export * from "./StyleTextIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports